import BaseFormPresenter from "../../../base/BaseFormPresenter";

class QueueingConfigPagePresenter extends BaseFormPresenter {
  constructor(view, getObjectUseCase, upsertUseCase, findObjectUseCase) {
    super();
    this.view = view;
    this.getObjectUseCase = getObjectUseCase;
    this.upsertUseCase = upsertUseCase;
    this.findObjectUseCase = findObjectUseCase;
  }

  componentDidMount() {
    this.init();
    this.findObjects();
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  init() {
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = [""];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  reset() {
    this.objects = [];
    this.objects2 = [];
    this.count = 0;
    this.current = 1;
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }

    return query;
  }

  showProgress() {
    this.progress = true;
    this.view.showProgress();
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const object = await this.findObjectUseCase.execute(collection, query);
      this.view.setObject(object[0]);
      this.view.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  onClickPrint() {
    this.view.exportPDF();
  }

  async submit() {
    const collection = this.view.getCollectionName();
    const { object } = this.view.state;
    try {
      this.view.showProgress();
      this.findObjectUseCase.abort();

      await this.upsertUseCase.execute(collection, object);
      this.view.hideProgress();
      this.view.success("Configuration Saved Successfully!");
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }
}

export default QueueingConfigPagePresenter;
